/**
 * Shown instead of a campaign (or one of its flights) when someone opens a direct link to a campaign an admin
 * soft-deleted (migration 203). Not an error: the campaign was hidden on purpose and its history is kept.
 */
import React from "react";
import type { Campaign } from "../../types/campaign.types";

interface Props {
  campaign: Pick<Campaign, "name" | "deleted_at">;
  onBack: () => void;
  backLabel?: string;
}

const DeletedCampaignNotice: React.FC<Props> = ({
  campaign,
  onBack,
  backLabel = "← Back to Campaigns",
}) => {
  const when = campaign.deleted_at
    ? new Date(campaign.deleted_at).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      })
    : null;
  return (
    <div className="p-6" data-testid="campaign-deleted-state">
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 max-w-2xl">
        <h1 className="text-xl font-semibold text-gray-900">
          This campaign was deleted
        </h1>
        <p className="mt-2 text-gray-700">
          <span className="font-medium">{campaign.name}</span> was deleted
          {when ? ` on ${when}` : ""} by an admin because it was never sent. It
          no longer appears in campaign lists and its flights cannot be
          scheduled or sent. Its history is kept.
        </p>
      </div>
      <button
        onClick={onBack}
        className="mt-4 px-4 py-2 text-primary-600 hover:text-primary-700"
      >
        {backLabel}
      </button>
    </div>
  );
};

export default DeletedCampaignNotice;
